import axios from "axios";
import Rx from "rxjs";

import { RAILS_API_URL } from "config/globals";

export class ApiServiceConstructor {
  apiVersion = 6;
  currentAdminUserEmail = null;
  currentAdminUserToken = null;
  currentCompanyId = null;
  locale = null;

  constructor() {
    this.axios = axios.create({
      baseURL: RAILS_API_URL,
      params: {},
      headers: {
        common: {
          "X-Api-Version": this.apiVersion,
          "X-Admin-Email": null,
          "X-Admin-Token": null,
        },
      },
    });
    this.setLocale(I18n.locale);
  }

  get apiUrl() {
    return this.axios.defaults.baseURL;
  }

  setLocale(locale) {
    this.locale = locale;
    this.axios.defaults.params.locale = locale || undefined;
  }

  setCurrentAdminUser(email, token) {
    this.currentAdminUserEmail = email;
    this.currentAdminUserToken = token;
    this.axios.defaults.headers.common["X-Admin-Email"] = this.currentAdminUserEmail || undefined;
    this.axios.defaults.headers.common["X-Admin-Token"] = this.currentAdminUserToken || undefined;
  }

  setCurrentCompany(companyId) {
    this.currentCompanyId = companyId;
    this.axios.defaults.params.current_company_id = this.currentCompanyId || undefined;
  }

  get(...args) {
    return Rx.Observable.fromPromise(this.axios.get.apply(this.axios, args));
  }

  post(...args) {
    return Rx.Observable.fromPromise(this.axios.post.apply(this.axios, args));
  }

  put(...args) {
    return Rx.Observable.fromPromise(this.axios.put.apply(this.axios, args));
  }

  patch(...args) {
    return Rx.Observable.fromPromise(this.axios.patch.apply(this.axios, args));
  }

  delete() {
    return Rx.Observable.fromPromise(this.axios.delete.apply(this.axios, arguments));
  }
}

export default new ApiServiceConstructor();



// WEBPACK FOOTER //
// ./src/lib/services/ApiService.js